import React, { lazy, ReactElement } from "react";
import { Permission } from "../lib/permission";
import { RoleName } from "../lib/session";
import { RouteProps } from "react-router";
import {
  Camera,
  ChartLine,
  ChartPieSlice,
  ClockAfternoon,
  Crosshair,
  FastForward,
  Gauge,
  ListBullets,
  ListChecks,
  ListDashes,
  ChatCircle,
  MapTrifold,
  NotePencil,
  Pulse,
  Rows,
  Screencast as CranecastIcon,
  SealCheck,
  Stack,
  Target,
} from "@phosphor-icons/react";

type Path = string;
export interface Route extends RouteProps {
  name: string;
  path: Path;
  permission?: Permission;
  allowedRoles: RoleName[];
  hidden?: boolean;
}

export interface MenuRoute extends Route {
  icon: ReactElement;
  parentMenu?: string;
  parentOverride?: boolean;
  parentIcon?: ReactElement;
}

export interface SettingRoute {
  name: string;
  permission?: Permission;
  subRoutes: Route[];
}

export const menuRoutes: MenuRoute[] = [
  // {
  //   name: "progress monitoring",
  //   path: "/progressMonitoring",
  //   permission: Permission.PM,
  //   allowedRoles: [RoleName.USER],
  //   icon: <ProgressMonitoringIcon />,
  //   component: lazy(() => import("../pages/ProgressMonitoring")),
  //   parentOverride: true,
  //   parentMenu: "progress monitoring",
  // },
  // {
  //   name: "dashboard",
  //   path: "/dashboard",
  //   permission: Permission.D,
  //   allowedRoles: [RoleName.USER],
  //   icon: <DashboardIconFilled />,
  //   component: lazy(() => import("../pages/Dashboard")),
  //   parentOverride: true,
  //   parentMenu: "dashboard",
  // },
  // {
  //   name: "dashboard",
  //   path: "/custom-dashboard",
  //   permission: Permission.CD,
  //   allowedRoles: [RoleName.USER],
  //   icon: <DashboardIcon />,
  //   component: lazy(() => import("../pages/CustomDashboard")),
  //   parentMenu: "Dashboard",
  //   parentIcon: <DashboardIconFilled />,
  // },
  {
    name: "cpo dashboard",
    path: "/cpo-dashboard",
    permission: Permission.CPOD,
    allowedRoles: [RoleName.USER, RoleName.CUSTOM],
    icon: <Gauge />,
    component: lazy(() => import("../pages/CPODashboard")),
    parentMenu: "Dashboard",
    parentIcon: <ChartPieSlice />,
  },
  // {
  //   name: "dashboard",
  //   path: "/dashboard",
  //   permission: Permission.MD,
  //   allowedRoles: [RoleName.USER],
  //   icon: <DashboardIconFilled />,
  //   component: lazy(() => import("../pages/Dashboard")),
  //   parentMenu: "Dashboard",
  //   parentIcon: <DashboardIconFilled />,
  // },
  // {
  //   name: "TV View",
  //   path: "/tv-view",
  //   permission: Permission.TV,
  //   allowedRoles: [RoleName.USER],
  //   icon: <DashboardIcon />,
  //   component: lazy(() => import("../pages/CustomDashboard")),
  //   parentMenu: "Dashboard",
  // },
  {
    name: "cameras",
    path: "/siteView",
    permission: Permission.SV,
    allowedRoles: [RoleName.USER, RoleName.CUSTOM],
    icon: <Camera />,
    component: lazy(() => import("../pages/SiteView")),
    parentMenu: "Site View",
    parentIcon: <MapTrifold />,
  },
  // {
  //   name: "project schedule",
  //   path: "/projectSchedule",
  //   permission: Permission.PS,
  //   allowedRoles: [RoleName.USER],
  //   icon: <ProjectScheduleIcon />,
  //   component: lazy(() => import("../pages/ProjectSchedule")),
  //   parentOverride: true,
  //   parentMenu: "project schedule",
  // },
  // {
  //   name: "gallery",
  //   path: "/gallery",
  //   permission: Permission.G,
  //   allowedRoles: [RoleName.USER],
  //   icon: <GalleryIcon />,
  //   component: lazy(() => import("../pages/Gallery")),
  //   parentOverride: true,
  //   parentMenu: "gallery",
  // },
  {
    name: "timelapse",
    path: "/timelapse",
    permission: Permission.TL,
    allowedRoles: [RoleName.USER, RoleName.CUSTOM],
    icon: <FastForward />,
    component: lazy(() => import("../pages/Timelapse")),
    parentMenu: "Site View",
  },
  {
    name: "live dashboard",
    path: "/live-dashboard",
    permission: Permission.LD,
    allowedRoles: [RoleName.USER, RoleName.CUSTOM],
    icon: <Pulse />,
    component: lazy(() => import("../pages/LiveDashboard")),
    parentMenu: "Site View",
  },
  {
    name: "livestream activity",
    path: "/siteView/livestream-activity",
    permission: Permission.SV,
    allowedRoles: [RoleName.ADMIN, RoleName.SITEADMIN],
    icon: <ListChecks />,
    component: lazy(() => import("../pages/LivestreamActivity")),
    parentMenu: "Site View",
  },
  {
    name: "camera online time",
    path: "/siteView/camera-online-time",
    permission: Permission.CHH,
    allowedRoles: [RoleName.ADMIN, RoleName.SITEADMIN],
    icon: <ClockAfternoon />,
    component: lazy(() => import("../pages/CameraOnlineTime")),
    parentMenu: "Site View",
  },
  // {
  //   name: "activity review",
  //   path: "/activityreview",
  //   permission: Permission.TL,
  //   allowedRoles: [RoleName.SITEADMIN],
  //   icon: <ListChecks />,
  //   component: lazy(() => import("../pages/ActivityReview")),
  //   parentMenu: "Site View",
  // },
  {
    name: "short range program",
    path: "/settings/shortRangePrograms",
    allowedRoles: [RoleName.USER, RoleName.CUSTOM],
    permission: Permission.SRP,
    icon: <ListDashes />,
    component: lazy(() => import("../pages/SettingsShortRangePrograms")),
    parentMenu: "Program Delivery",
    parentIcon: <Rows />,
  },
  {
    name: "Platform List",
    path: "/platform/list",
    permission: Permission.PI,
    allowedRoles: [RoleName.USER, RoleName.CUSTOM],
    icon: <ListBullets />,
    component: lazy(() => import("../pages/Platform/PlatformList")),
    parentMenu: "Platform",
    parentIcon: <SealCheck />,
  },
  {
    name: "Daily Inspection History",
    path: "/platform/inspect-history",
    permission: Permission.PI,
    allowedRoles: [RoleName.USER, RoleName.CUSTOM],
    icon: <NotePencil />,
    component: lazy(
      () => import("../pages/Platform/PlatformInspectionHistory"),
    ),
    parentMenu: "Platform",
    parentIcon: <SealCheck />,
  },

  {
    name: "Installation Declaration History",
    path: "/platform/installation-history",
    permission: Permission.PI,
    allowedRoles: [RoleName.USER, RoleName.CUSTOM],
    icon: <Stack />,
    component: lazy(() => import("../pages/Platform/PlatformInstallationList")),
    parentMenu: "Platform",
    parentIcon: <SealCheck />,
  },
  {
    name: "Platform Status",
    path: "/platform/inspect",
    permission: Permission.PI,
    allowedRoles: [RoleName.USER, RoleName.CUSTOM],
    hidden: true,
    icon: <Crosshair />,
    component: lazy(() => import("../pages/Platform")),
    parentMenu: "Platform",
    parentIcon: <SealCheck />,
  },
  {
    name: "long range program",
    path: "/settings/longRangePrograms",
    allowedRoles: [RoleName.SITEADMIN],
    permission: Permission.LRP,
    icon: <Rows />,
    component: lazy(() => import("../pages/SettingsLongRangePrograms")),
    parentMenu: "Program Delivery",
  },
  {
    name: "analytics",
    path: "/cranecastAnalytics",
    icon: <ChartLine />,
    allowedRoles: [RoleName.SITEADMIN, RoleName.ADMIN, RoleName.USER, RoleName.CUSTOM],
    permission: Permission.CH,
    component: lazy(() => import("../pages/CranecastAnalytics")),
    parentMenu: "Cranecast",
    parentIcon: <CranecastIcon />,
  },
  // {
  //   name: "GPS Stream",
  //   path: "/gpsware",
  //   permission: Permission.TL,
  //   allowedRoles: [RoleName.SITEADMIN],
  //   icon: <MapPin />,
  //   component: lazy(() => import("../pages/GPSWare/Coordinates")),
  //   parentMenu: "Cranecast",
  // },
  {
    name: "Chat",
    path: "/chat",
    allowedRoles: [RoleName.USER, RoleName.CUSTOM],
    icon: <ChatCircle />,
    component: lazy(() => import("../pages/AIAssistant")),
    parentOverride: true,
    parentMenu: "Chat",
  },
];

export const viewerMenuRoutes: MenuRoute[] = [
  {
    name: "timelapse",
    path: "/timelapse",
    permission: Permission.TL,
    allowedRoles: [RoleName.VIEWER],
    icon: <FastForward />,
    component: lazy(() => import("../pages/Timelapse")),
    parentOverride: true,
    parentMenu: "timelapse",
  },
];

export const viewerRoutes: Route[] = [
  {
    name: "timelapse",
    path: "/timelapse",
    permission: Permission.TL,
    allowedRoles: [RoleName.VIEWER],
    component: lazy(() => import("../pages/Timelapse")),
  },
  {
    name: "projects",
    path: "/projects",
    allowedRoles: [RoleName.VIEWER],
    component: lazy(() => import("../pages/Projects")),
  },
  // {
  //   name: "live",
  //   path: "/live",
  //   allowedRoles: [RoleName.VIEWER],
  //   permission: Permission.L,
  //   component: lazy(() => import("../pages/Live")),
  // },
];

export const monitorMenuRoutes: MenuRoute[] = [
  {
    name: "live dashboard",
    path: "/live-dashboard",
    permission: Permission.LD,
    allowedRoles: [RoleName.MONITOR],
    icon: <Pulse />,
    component: lazy(() => import("../pages/LiveDashboard")),
    parentOverride: true,
    parentMenu: "live dashboard",
  },
];

export const monitorRoutes: Route[] = [
  {
    name: "live dashboard",
    path: "/live-dashboard",
    permission: Permission.LD,
    allowedRoles: [RoleName.MONITOR],
    component: lazy(() => import("../pages/LiveDashboard")),
  },
  {
    name: "projects",
    path: "/projects",
    allowedRoles: [RoleName.MONITOR],
    component: lazy(() => import("../pages/Projects")),
  },
];

export const adminRoutes: MenuRoute[] = [
  {
    name: "timeline",
    path: "/cranecastTimeline",
    icon: <ClockAfternoon />,
    allowedRoles: [RoleName.SITEADMIN, RoleName.ADMIN, RoleName.USER, RoleName.CUSTOM],
    permission: Permission.CT,
    component: lazy(() => import("../pages/CranecastTimeline")),
    parentMenu: "Cranecast",
    parentIcon: <CranecastIcon />,
  },
  {
    name: "video analysis",
    path: "/cranecast/video-analysis",
    icon: <FastForward />,
    allowedRoles: [RoleName.SITEADMIN, RoleName.ADMIN, RoleName.USER, RoleName.CUSTOM],
    permission: Permission.CT,
    component: lazy(() => import("../pages/CraneVideoAnalysis")),
    parentMenu: "Cranecast",
    parentIcon: <CranecastIcon />,
  },
  {
    name: "Jibtracker",
    path: "/cranecast/jibtracker",
    icon: <Target />,
    allowedRoles: [RoleName.SITEADMIN, RoleName.ADMIN, RoleName.USER, RoleName.CUSTOM],
    // If they have permission to view the timeline, they should also have permission to view the jibtracker
    permission: Permission.CT,
    component: lazy(() => import("../pages/Cranecast/Jibtracker")),
    parentMenu: "Cranecast",
    parentIcon: <CranecastIcon />,
  },
  // {
  //   name: "project zone",
  //   path: "/projectZone",
  //   icon: <LandPlot />,
  //   allowedRoles: [RoleName.SITEADMIN],
  //   permission: Permission.TL,
  //   component: lazy(() => import("../pages/ProjectZone")),
  //   parentMenu: "Cranecast",
  //   parentIcon: <CranecastIcon />,
  // },
  {
    name: "lift review",
    path: "/craneLift",
    icon: <ListChecks />,
    allowedRoles: [RoleName.SITEADMIN, RoleName.USER, RoleName.CUSTOM],
    component: lazy(() => import("../pages/CraneLifts")),
    permission: Permission.CLR,
    parentMenu: "Cranecast",
    parentIcon: <CranecastIcon />,
  },
  // {
  //   name: "section sensor",
  //   path: "/sectionSensor",
  //   permission: Permission.SS,
  //   allowedRoles: [RoleName.SITEADMIN],
  //   icon: <SectionSensorIcon />,
  //   component: lazy(() => import("../pages/SectionSensor")),
  //   parentOverride: true,
  //   parentMenu: "section sensor",
  // },
];

export const settingRoutes: SettingRoute[] = [
  {
    name: "site",
    subRoutes: [
      {
        name: "locations",
        path: "/settings/locations",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsLocations")),
      },
      {
        name: "areas",
        path: "/settings/areas",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsAreas")),
      },
      {
        name: "activities",
        path: "/settings/activities",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsActivities")),
      },
      {
        name: "trade",
        path: "/settings/trade",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsTrade")),
      },
      {
        name: "material",
        path: "/settings/material",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsMaterial")),
      },
      {
        name: "trades & materials",
        path: "/settings/trade-materials",
        allowedRoles: [RoleName.ADMIN, RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsTradeMaterials")),
      },
      {
        name: "material edit",
        path: "/settings/material/:materialId",
        allowedRoles: [RoleName.SITEADMIN],
        hidden: true,
        component: lazy(
          () => import("../pages/SettingsMaterial/MaterialEditorPage")
        ),
      },
      {
        name: "knowledge",
        path: "/settings/knowledge",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsKnowledge")),
      },
      {
        name: "suppliers",
        path: "/settings/suppliers",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsSuppliers")),
      },
      {
        name: "contractors",
        path: "/settings/contractors",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsContractors")),
      },
      // {
      //   name: "allocations",
      //   path: "/settings/allocations",
      //   allowedRoles: [RoleName.ADMIN],
      //   component: lazy(() => import("../pages/SettingsAllocations")),
      // },
      {
        name: "calendars",
        path: "/settings/calendars",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsCalendars")),
      },
      {
        name: "calendar dates",
        path: "/settings/calendarDates",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsCalendarDates")),
      },
      {
        name: "short range programs",
        path: "/settings/shortRangePrograms",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsShortRangePrograms")),
      },
      {
        name: "short range program activities",
        path: "/settings/shortRangeProgramActivities",
        allowedRoles: [RoleName.USER, RoleName.SITEADMIN, RoleName.CUSTOM],
        hidden: true,
        component: lazy(
          () => import("../pages/SettingsShortRangeProgramActivities"),
        ),
      },
      {
        name: "long range programs",
        path: "/settings/longRangePrograms",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsLongRangePrograms")),
      },
      {
        name: "long range program activities",
        path: "/settings/longRangeProgramActivities",
        allowedRoles: [RoleName.SITEADMIN],
        hidden: true,
        component: lazy(
          () => import("../pages/SettingsLongRangeProgramActivities"),
        ),
      },
      {
        name: "custom configuration",
        path: "/settings/custom",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsCustom")),
      },
      // {
      //   name: "weekly history",
      //   path: "/settings/weeklyHistory",
      //   allowedRoles: [RoleName.ADMIN],
      //   hidden: true,
      //   component: lazy(() => import("../pages/SettingsWeeklyHistory")),
      // },
    ],
  },
  {
    name: "notifications",
    subRoutes: [
      {
        name: "address book",
        path: "/settings/addressBook",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsNotificationUsers")),
      },
      // {
      //   name: "schedules",
      //   path: "/settings/schedules",
      //   allowedRoles: [RoleName.ADMIN],
      //   component: lazy(() => import("../pages/SettingsSchedules")),
      // },
      // {
      //   name: "schedule policies",
      //   path: "/settings/schedulePolicies",
      //   allowedRoles: [RoleName.ADMIN],
      //   component: lazy(() => import("../pages/SettingsSchedulePolicies")),
      // },
    ],
  },
  {
    name: "reports",
    subRoutes: [
      // {
      //   name: "daily updates",
      //   path: "/settings/dailyUpdates",
      //   allowedRoles: [RoleName.USER],
      //   component: lazy(() => import("../pages/SettingsDailyUpdates")),
      // },
      // {
      //   name: "man steel concrete",
      //   path: "/settings/hoursSteelConcrete",
      //   allowedRoles: [RoleName.USER],
      //   component: lazy(() => import("../pages/ManSteelConcrete")),
      //   permission: Permission.MSC,
      // },
    ],
  },
  {
    name: "devices",
    subRoutes: [
      {
        name: "cameras",
        path: "/settings/cameras",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/Camera")),
      },
      {
        name: "cranes",
        path: "/settings/cranes",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/Crane")),
      },
      {
        name: "wind sensors",
        path: "/settings/windSensors",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsWindSensor")),
      },
      {
        name: "polygons",
        path: "/settings/polygons",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/Polygon")),
      },
      {
        name: "material images",
        path: "/material-images",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/MaterialImage")),
      },

      {
        name: "GPS",
        path: "/gps",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/GPSWare")),
      },
      {
        name: "video analysis",
        path: "/settings/video-analysis",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsVideoAnalysis")),
      },
    ],
  },
  {
    name: "permissions",
    subRoutes: [
      {
        name: "group permissions",
        path: "/settings/permissions",
        allowedRoles: [RoleName.SITEADMIN],
        component: lazy(() => import("../pages/SettingsPermissions")),
      },
    ],
  },
  // {
  //   name: "weeklyschedule",
  //   permission: Permission.WS,
  //   subRoutes: [
  //     {
  //       name: "weeklyschedule",
  //       path: "/settings/weeklyschedule",
  //       allowedRoles: [RoleName.USER],
  //       component: lazy(() => import("../pages/WeeklyScheduleActivity")),
  //       permission: Permission.WS,
  //     },
  //   ],
  // },
  //
  // {
  //   name: "pour breakdown",
  //   permission: Permission.PB,
  //   subRoutes: [
  //     {
  //       name: "pour breakdown",
  //       path: "/settings/pourBreakdown",
  //       allowedRoles: [RoleName.USER],
  //       component: lazy(() => import("../pages/PourBreakdown")),
  //       permission: Permission.PB,
  //     },
  //   ],
  // },
  // {
  //   name: "labour onsite",
  //   permission: Permission.TLO,
  //   subRoutes: [
  //     {
  //       name: "total labour onsite",
  //       path: "/settings/totallabouronsite",
  //       allowedRoles: [RoleName.USER],
  //       component: lazy(() => import("../pages/TotalLabourOnsite")),
  //       permission: Permission.TLO,
  //     },
  //   ],
  // },
];

export default (menuRoutes as Route[])
  .concat(
    settingRoutes.reduce((accumulation: Route[], current: SettingRoute) => {
      return accumulation.concat(current.subRoutes);
    }, []),
  )
  .concat([
    {
      name: "projects",
      path: "/projects",
      allowedRoles: [RoleName.USER, RoleName.CUSTOM],
      component: lazy(() => import("../pages/Projects")),
    },
    {
      name: "settings",
      path: "/settings",
      permission: Permission.S,
      allowedRoles: [RoleName.SITEADMIN, RoleName.ADMIN],
      component: lazy(() => import("../pages/Settings")),
    },
    // {
    //   name: "live",
    //   path: "/live",
    //   permission: Permission.L,
    //   allowedRoles: [RoleName.USER],
    //   component: lazy(() => import("../pages/Live")),
    // },
    {
      name: "slideshow",
      path: "/slideshow",
      permission: Permission.LV,
      allowedRoles: [RoleName.USER, RoleName.CUSTOM],
      component: lazy(() => import("../pages/Slideshow")),
    },
    // {
    //   name: "survey submit",
    //   path: "/surveySubmit",
    //   allowedRoles: [RoleName.USER],
    //   component: lazy(() => import("../pages/SurveySubmit")),
    // },
  ]);
